import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations générales", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)
const _hoisted_9 = { class: "table" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Référence", -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Montant total", -1)
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Remise", -1)
const _hoisted_16 = { key: 3 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Montant total après remise", -1)
const _hoisted_18 = { key: 4 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Date Commande", -1)
const _hoisted_20 = { key: 5 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Code coupon", -1)
const _hoisted_22 = { key: 6 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Client", -1)
const _hoisted_24 = { key: 7 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Mode de paiement", -1)
const _hoisted_26 = { key: 8 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Mode de livraison", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Livreur", -1)
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_30 = { class: "col-md-12 col-xl-12 col-sm-12 mb-10" }
const _hoisted_31 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_32 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_33 = { class: "text-black fw-bold mb-10" }
const _hoisted_34 = { class: "table" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Produit "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Prix "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Montant "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Quantité ")
  ])
], -1)
const _hoisted_36 = { class: "col-md-12 col-xl-12 col-sm-12 mb-10" }
const _hoisted_37 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_38 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h4", { class: "text-black fw-bold mb-10" }, "Information de livraison :", -1)
const _hoisted_40 = { class: "table" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Adresse", -1)
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Email", -1)
const _hoisted_45 = { key: 2 }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Telephone", -1)
const _hoisted_47 = { key: 3 }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Pays", -1)
const _hoisted_49 = { key: 4 }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Commune", -1)
const _hoisted_51 = { key: 5 }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Ville", -1)
const _hoisted_53 = { class: "col-md-12 col-xl-12 col-sm-12 mb-10" }
const _hoisted_54 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_55 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("h4", { class: "text-black fw-bold mb-10" }, "Suivi de la commande", -1)
const _hoisted_57 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Ordre "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Libellé "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Observation "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Date ")
  ])
], -1)
const _hoisted_59 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_60 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_61 = { class: "badge badge-outline-danger text-outline-primary" }
const _hoisted_62 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_63 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_router_link, {
              to: "/liste-commandes",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8,
                _createTextVNode("Retour")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("tbody", null, [
              (_ctx.commande?.refCommande)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("td", null, _toDisplayString(_ctx.commande?.refCommande), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.commande?.montantTotal)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("td", null, _toDisplayString(_ctx.commande?.montantTotal), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.commande?.remise)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("td", null, _toDisplayString(_ctx.commande?.remise), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.commande?.montantTotalApresRemise)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("td", null, _toDisplayString(_ctx.commande?.montantTotalApresRemise), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.commande?.dateCommande)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("td", null, _toDisplayString(_ctx.format_date(_ctx.commande?.dateCommande)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.commande?.coupon)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("td", null, _toDisplayString(_ctx.commande.coupon.code), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.commande?.client)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("td", null, _toDisplayString(_ctx.commande.client?.nomComplet), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.commande?.moyenPaiement)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("td", null, _toDisplayString(_ctx.commande?.moyenPaiement.libelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.commande?.modeLivraison)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("td", null, _toDisplayString(_ctx.commande?.modeLivraison.libelle), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _hoisted_28,
                _createElementVNode("td", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commande?.users, (user, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: user.id
                    }, [
                      _createElementVNode("p", {
                        class: _normalizeClass({'text-green': index === _ctx.commande.users.length - 1})
                      }, _toDisplayString(user.nomComplet), 3)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("h4", _hoisted_33, "Produits dans la commande : " + _toDisplayString(_ctx.totalCommande) + " au total", 1),
          _createElementVNode("table", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commande?.produitCommandes, (produitCommande) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: produitCommande.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(produitCommande.produit.title), 1),
                  _createElementVNode("td", null, _toDisplayString(produitCommande.produit.price), 1),
                  _createElementVNode("td", null, _toDisplayString(produitCommande.montant), 1),
                  _createElementVNode("td", null, _toDisplayString(produitCommande.quantite), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("table", _hoisted_40, [
            _createElementVNode("tbody", null, [
              (_ctx.commande?.adresseLivraison)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("td", null, _toDisplayString(_ctx.commande?.adresseLivraison?.adresse), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.commande?.adresseLivraison)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("td", null, _toDisplayString(_ctx.commande?.adresseLivraison?.email), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.commande?.adresseLivraison)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("td", null, _toDisplayString(_ctx.commande?.adresseLivraison?.telephone), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.commande?.adresseLivraison)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_47, [
                    _hoisted_48,
                    _createElementVNode("td", null, _toDisplayString(_ctx.commande?.adresseLivraison?.pays?.nom_fr_fr), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.commande?.adresseLivraison)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("td", null, _toDisplayString(_ctx.commande?.adresseLivraison?.commune?.libelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.commande?.adresseLivraison)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_51, [
                    _hoisted_52,
                    _createElementVNode("td", null, _toDisplayString(_ctx.commande?.adresseLivraison?.ville), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _createElementVNode("table", _hoisted_57, [
            _hoisted_58,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commande?.suivicommandes, (suivicommande) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: suivicommande.id
                }, [
                  _createElementVNode("td", _hoisted_59, _toDisplayString(suivicommande?.statutcommande?.ordre), 1),
                  _createElementVNode("td", _hoisted_60, [
                    _createElementVNode("span", _hoisted_61, _toDisplayString(suivicommande?.statutcommande?.libelle), 1)
                  ]),
                  _createElementVNode("td", _hoisted_62, _toDisplayString(suivicommande?.observation), 1),
                  _createElementVNode("td", _hoisted_63, _toDisplayString(_ctx.format_Date( suivicommande.dateSuivi )), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}